// extracted by mini-css-extract-plugin
export var contrastLow = "_7-1";
export var externalLink = "_7-2";
export var externalLinkIcon = "_7-3";
export var link = "_7-0";
export var linkLabel = "_7-4";